import React from "react"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import Avatar from "@material-ui/core/Avatar"
import ListItem from "@material-ui/core/ListItem"
import { Link } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import { split, reduce } from "ramda"
import styled from "@emotion/styled"
import { sameName, siblingsNotMe } from "../utils/my-products"
const AvatarWrapper = styled.div`
  height: 48px;
  width: 48px;
  object-fit: contain;
  padding: 0px;
  opacity: 0.6;
`
const MyAvatar = ({ item, avatares, isDir }) => {
  if (isDir) {
    return (
      <img
        style={{ width: "48px", height: "48px", borderRadius: "4px", paddingTop: 0, paddingLeft: 0 }}
        src={"/folder.svg"}
        alt=""
      />
    )
  }
  // HAS_IMAGEN: "HAS_IMAGEN",
  if (item.frontmatter.imagen && item.frontmatter.imagen.source) {
    return (
      <AvatarWrapper>
        <Img
          objectFit="contain"
          style={{ width: "48px", height: "48px", borderRadius: "4px", }}
          fixed={item.frontmatter.imagen.source.childImageSharp.fixed}
        />
      </AvatarWrapper>
    )
  }
  // HAS_GALLERY: "HAS_GALLERY",
  else if (item.frontmatter.galeria && item.frontmatter.galeria.length > 0 && item.frontmatter.galeria[0].source) {
    return (
      <AvatarWrapper>
        <Img
          style={{ width: "48px", height: "48px", borderRadius: "4px", paddingTop: 0, paddingLeft: 0 }}
          fixed={item.frontmatter.galeria[0].source.childImageSharp.fixed}
        />
      </AvatarWrapper>
    )
  }
  // HAS_AVATAR: "HAS_AVATAR",
  else if (item.frontmatter.galeria && item.frontmatter.galeria.length > 0 && item.frontmatter.galeria[0].source) {
    return (
      <AvatarWrapper>
        <Img
          style={{ width: "48px", height: "48px", borderRadius: "4px", paddingTop: 0, paddingLeft: 0 }}
          fixed={item.frontmatter.galeria[0].source.childImageSharp.fixed}
        />
      </AvatarWrapper>
    )
  } else if (item.frontmatter.avatar) {
    return (
      <AvatarWrapper>
        <img
          style={{ width: "48px", height: "48px", borderRadius: "4px", paddingTop: 0, paddingLeft: 0 }}
          src={"/" + item.frontmatter.avatar + ".svg"}
          alt=""
        />
      </AvatarWrapper>
    )
  } else {
    // Ok. If we are here the situation is desperate
    // Let's search for an avatar from the ancestry ...
    // HAS_ANCESTOR: "HAS_ANCESTOR",
    const steps = split("/", item.slug)
    if (avatares) {
      const theAvatar = reduce(
        (avatar, pointName) =>
          reduce((avatar, candidate) => {
            return avatar
              ? avatar
              : pointName === candidate.nombre
                ? candidate.source.base
                : false
          }, avatar)(avatares),
        false
      )(steps)
      if (theAvatar) {
        return (
          <AvatarWrapper>
            <img
              style={{ width: "48px", height: "48px", borderRadius: "4px", paddingTop: 0, paddingLeft: 0 }}
              src={"/" + theAvatar}
              alt=""
            />
          </AvatarWrapper>
        )
      }
    } else {
      return (
        <img
          style={{ width: "48px", height: "48px", borderRadius: "4px", paddingTop: 0, paddingLeft: 0 }}
          src={"/folder.svg"}
          alt=""
        />
      )
    }
  }
  //   HAS_NOTHING: "HAS_NOTHING",
  return (
    <ListItemAvatar>
      <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
    </ListItemAvatar>
  )
}

//  color: ${props => (props.isDir ? "#3f51b5" : "black")};
 const EntryWrapper = styled.div`
  background-color: #f8f8f8;
  :hover {
    background-color: #f0f0f0;
  }
  & a:hover {
    opacity: 1;
  }
`

const Entry = ({ item, avatares, list }) => {
  const isDir = sameName(item.slug) && siblingsNotMe(item, list).length > 0
  const entry = (
    <EntryWrapper isDir={isDir}>
      <Link to={"/content/productos/" + item.slug}>
        <ListItem alignItems="flex-start" >
          <MyAvatar item={item} avatares={avatares} isDir={isDir} />
          <ListItemText
            color="secondary"
            primary={
              <span style={{ fontSize: 16 }}>{item.frontmatter.title}</span>
            }
            secondary={item.frontmatter.subtitle}
            style={{ paddingLeft: "12px", marginTop: 0 }}
          />
        </ListItem>
      </Link>
    </EntryWrapper>
  )
  return entry
}

export default Entry
